import {createContext, Dispatch, PropsWithChildren, ReactElement, useContext, useState} from "react";
import {createPortal} from "react-dom";

const GlobalModalContext = createContext<{
    modal: ReactElement | null;
    setModal: Dispatch<ReactElement | null>;
} | null>(null);

export const GlobalModalProvider = ({children}: PropsWithChildren) => {
    const [modal, setModal] = useState<ReactElement | null>(null);
    return (
        <GlobalModalContext.Provider
            value={{
                modal,
                setModal,
            }}
        >
            {children}
            {modal !== null ? createPortal(modal, document.body) : null}
        </GlobalModalContext.Provider>
    );
};

export function useGlobalModal() {
    const context = useContext(GlobalModalContext);
    const noop = () => {
    };
    if (context !== null) {
        return {
            open:  context.setModal,
            close: () => context.setModal(null),
        };
    }
    return {open: noop, close: noop};
}
